// Static content shared across the marketing site.

export const GESIL_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_gesil-govtech/artifacts/rpcdvh9x_GESILLOGO.png";

export const COMPANY = {
  name: "Global e-Village Services India Ltd",
  short: "GESIL",
  tagline: "Powering Your Future Bright",
  alt_tagline: "Transforming Governance Through Technology",
  email_primary: "info@gesil.co.in",
  email_secondary: "admin@gesil.tech",
  toll_free: "1800 890 4368",
  head_office: {
    label: "Head Office",
    address: "N1/290, 2nd Floor, IRC Village, Nayapalli, Bhubaneswar, Odisha — 751015",
  },
  corporate_office: {
    label: "Corporate Office",
    address: "3rd Floor, OCAC Tower, Acharya Vihar, Bhubaneswar — 751013, Odisha",
  },
};

export const STATS = [
  { label: "Government Projects", value: 50, suffix: "+" },
  { label: "Departments Digitized", value: 20, suffix: "+" },
  { label: "Citizens Impacted", value: 10, suffix: "M+" },
  { label: "Years of Governance Expertise", value: 10, suffix: "+" },
];

/**
 * GOVERNMENT DOMAINS where GESIL has delivered platforms, projects, and PMU
 * engagements. This is the full coverage map — not a curated "pillar" list.
 */
export const DOMAINS = [
  { title: "Agriculture & Farmer Welfare", icon: "Sprout",
    items: ["Digital Agriculture Platforms", "Farmer Services", "Crop Intelligence", "Subsidy Management", "AI Advisory Systems"] },
  { title: "Finance, Commercial Tax & Treasury", icon: "Landmark", tag: "Finance & Taxation",
    items: ["GST State Repository", "Revenue Analytics", "Treasury Systems", "Financial Management", "Compliance Platforms"] },
  { title: "Housing & Urban Development", icon: "Building2", tag: "Urban Governance",
    items: ["Municipal Revenue Platform", "Property Tax", "Trade License", "Water Charges", "Citizen Service Portals"] },
  { title: "Social Justice & Empowerment", icon: "ShieldCheck", tag: "Social Justice",
    items: ["SAACAR Compensation Monitoring", "Beneficiary Management", "DBT Platforms", "Welfare Analytics", "Social Inclusion Systems"] },
  { title: "ST & SC Development, Minorities, BCW", icon: "HeartHandshake", tag: "Welfare",
    items: ["Scholarship Management", "Hostel Management", "Skill Programmes", "Tribal Welfare Tracking", "Concurrence Workflows"] },
  { title: "Handlooms, Textiles & Handicrafts", icon: "Layers", tag: "Handlooms & Textiles",
    items: ["Artisan Registries", "Handloom Marketplaces", "Cluster Monitoring", "Export Promotion", "Craft Digitization"] },
  { title: "Higher Education & Skill Development", icon: "GraduationCap", tag: "Higher Education",
    items: ["Student Lifecycle Systems", "Scholarship Portals", "Affiliation Workflows", "Skill Mission Platforms", "Industry Partnerships"] },
  { title: "School & Mass Education", icon: "BookOpen", tag: "Education",
    items: ["UDISE Integrations", "Student Performance Analytics", "Mid-Day Meal Tracking", "Teacher Workflows", "School Infra MIS"] },
  { title: "Health & Family Welfare", icon: "Stethoscope",
    items: ["Programme MIS", "Beneficiary Health Cards", "Hospital Workflow", "Public Health Dashboards", "Telemedicine Hooks"] },
  { title: "Women & Child Development", icon: "Baby",
    items: ["Anganwadi MIS", "Nutrition Tracking", "Mission Shakti Portals", "Adolescent Programmes", "Childline Coordination"] },
  { title: "Public Service Commission & Administrative Reforms", icon: "ClipboardList", tag: "Administrative Reforms",
    items: ["OPSC Promotion & Disciplinary", "Concurrence Management", "Cadre Reviews", "ACR / APAR Systems", "Audit Trails"] },
  { title: "Energy, Power & Renewables", icon: "Zap",
    items: ["DISCOM Dashboards", "Distribution Loss Analytics", "Renewables Tracking", "Subsidy Reconciliation", "GIS Asset MIS"] },
  { title: "Forest, Environment & Climate Change", icon: "Trees",
    items: ["Forest Beat MIS", "Wildlife Monitoring", "Carbon & Climate Dashboards", "Compensatory Afforestation", "Eco-Tourism Portals"] },
  { title: "Tourism & Culture", icon: "Mountain", tag: "Heritage",
    items: ["Destination Portals", "Heritage Listings", "Tour Operator Onboarding", "Festival Workflows", "Tourism Analytics"] },
  { title: "Industries & MSME", icon: "Factory", tag: "E-Commerce",
    items: ["Single Window Clearance", "Investment Tracking", "Incentive Disbursal", "Cluster MIS", "Export Promotion"] },
  { title: "Rural Development & Panchayati Raj", icon: "Tractor",
    items: ["MGNREGS Dashboards", "Gram Panchayat Workflows", "Asset Geo-tagging", "Drinking Water MIS", "Beneficiary Schemes"] },
  { title: "Cooperation & Food Supplies", icon: "Wheat", tag: "Cooperative",
    items: ["PDS Analytics", "Procurement MIS", "Cooperative Society Workflows", "Granary Stock Tracking", "Subsidy Management"] },
  { title: "Steel, Mines & Geology", icon: "Pickaxe",
    items: ["Lease MIS", "Royalty Reconciliation", "Mining Transport Permits", "Mineral Auctions", "GIS Asset Maps"] },
  { title: "Transport & Commerce", icon: "Bus",
    items: ["Permit Workflows", "Fitness Certification", "Tax Collection Dashboards", "RTO Service Delivery", "Fleet Analytics"] },
  { title: "Sports, Youth Services & Tourism", icon: "Trophy",
    items: ["Athlete Registries", "Coaching Workflows", "Event Management", "Youth Programmes", "Volunteer Networks"] },
  { title: "Disaster Management & Public Safety", icon: "Siren",
    items: ["Early Warning Dashboards", "Relief Disbursal", "Damage Assessment", "Volunteer Coordination", "Inter-agency Workflows"] },
  { title: "Artificial Intelligence Mission", icon: "Brain", tag: "Artificial Intelligence",
    items: ["Odisha AI Mission Portal", "Startup Sandboxes", "Policy Intelligence", "Research Grants", "Citizen AI Services"] },
];

export const AI_SOLUTIONS = [
  "RAG Knowledge Systems",
  "Enterprise AI Assistants",
  "Government Chatbots",
  "Policy Intelligence",
  "Document Intelligence",
  "AI Search",
  "AI Analytics",
  "AI Report Generation",
  "Predictive Governance",
];

export const DEPLOYMENT_MODELS = [
  "On Premise",
  "Private Cloud",
  "State Data Centre",
  "Hybrid Cloud",
];

export const SUPPORTED_MODELS = [
  "Llama",
  "DeepSeek",
  "Mistral",
  "Gemma",
  "Qwen",
  "Phi",
  "Sarvam AI",
];

export const SERVICES = [
  { title: "Digital Governance", icon: "Network" },
  { title: "eGovernance Platforms", icon: "Building2" },
  { title: "Citizen Service Delivery", icon: "Users" },
  { title: "Enterprise Applications", icon: "AppWindow" },
  { title: "GIS Platforms", icon: "Map" },
  { title: "AI & Machine Learning", icon: "Brain" },
  { title: "Cloud Migration", icon: "Cloud" },
  { title: "System Integration", icon: "Combine" },
  { title: "API Platforms", icon: "Webhook" },
  { title: "Data Analytics", icon: "BarChart3" },
  { title: "Decision Support Systems", icon: "GitBranch" },
  { title: "Cyber Security", icon: "ShieldAlert" },
  { title: "Managed Services", icon: "Server" },
  { title: "AMC Support", icon: "Wrench" },
  { title: "PMU Services", icon: "ClipboardList" },
  { title: "Consulting Services", icon: "Briefcase" },
];

export const CLIENT_LOGOS = [
  "Government of Odisha",
  "Commissionerate of CT & GST",
  "OCAC",
  "Housing & Urban Development",
  "OPSC",
  "ST & SC Development Dept.",
  "Department of Agriculture",
  "Bhubaneswar Municipal Corporation",
  "Cuttack Municipal Corporation",
  "Odisha AI Mission",
  "Directorate of Treasuries",
  "Higher Education Dept.",
];

export const UNIDAF_FEATURES = [
  { title: "Multimodal AI", desc: "Text, vision and document understanding in one platform." },
  { title: "RAG Framework", desc: "Grounded answers from departmental knowledge bases." },
  { title: "Knowledge Management", desc: "Structured ingestion of files, GO orders and SOPs." },
  { title: "Open Source LLM Integration", desc: "Llama, Mistral, Gemma, DeepSeek, Sarvam AI." },
  { title: "Prompt Orchestration", desc: "Composable agents and workflows by role." },
  { title: "Analytics Engine", desc: "Adoption, accuracy and audit dashboards." },
  { title: "Enterprise Security", desc: "Role-based access, audit logs, SSO ready." },
  { title: "Government Ready Deployment", desc: "On-prem, SDC and private cloud." },
];
